import { render, staticRenderFns } from "./SummaryReport.vue?vue&type=template&id=2668dd84&"
import script from "./SummaryReport.vue?vue&type=script&lang=js&"
export * from "./SummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports